import React from "react";
import { View, StyleSheet } from "@react-pdf/renderer";
import InvoiceTableHeader from "./InvoiceTableHeader";
import InvoiceTableRow from "./InvoiceTableRow";
import InvoiceTableBlankSpace from "./InvoiceTableBlankSpace";
import InvoiceTableFooter from "./InvoiceTableFooter";
import InvoiceTableDFooter from "./InvoiceTableDFooter";
import InvoiceTableDueFooter from "./InvoiceTableDueFooter";

const tableRowsCount = 15;

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 24,
    borderWidth: 1,
  },
});

const InvoiceItemsTable = ({ invoice, discount, previousDue }) => (
  <View style={styles.tableContainer}>
    <InvoiceTableHeader />
    <InvoiceTableRow items={invoice.items} />
    <InvoiceTableBlankSpace rowsCount={tableRowsCount - invoice.items.length} />
    <InvoiceTableDFooter discount={discount} />
    <InvoiceTableDueFooter previousDue={previousDue} />
    <InvoiceTableFooter
      items={invoice.items}
      discount={discount}
      previousDue={previousDue}
    />
  </View>
);

export default InvoiceItemsTable;
